export class Image {
    fileName: string;
    id: number;
    idParent: string;
    status: string;

    public static createFromJson(json: any): Image {
        const entity = new Image();
        entity.fileName = json.fileName;
        entity.id = json.id;
        entity.idParent = json.idParent;
        entity.status = json.status;
        return entity;
    }

}
